/**
 * Appends email to display names when duplicate names exist in a list.
 * e.g., "Nisha Rana" appears twice → "Nisha Rana (nisha1@email.com)" and "Nisha Rana (nisha2@email.com)"
 */
export function disambiguateNames<T extends Record<string, any>>(
  items: T[],
  nameKey: string,
  emailKey: string,
): T[] {
  const nameCount = new Map<string, number>();
  for (const item of items) {
    const name = item[nameKey];
    if (name) {
      nameCount.set(name, (nameCount.get(name) || 0) + 1);
    }
  }

  return items.map((item) => {
    const name = item[nameKey];
    const email = item[emailKey];
    if (name && nameCount.get(name)! > 1 && email) {
      return { ...item, [nameKey]: `${name} (${email})` };
    }
    return item;
  });
}
